import React from 'react';
import {
  useHistory
} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import { ExitToAppOutlined, HomeOutlined, ListOutlined, LockOutlined } from '@material-ui/icons';

import { HomeIcon } from './components/icon';
import Logo from './assets/logo.png';

const useStyles = makeStyles((theme) => ({
  paper: {
    // backgroundColor: theme.palette.primary,
    background: theme.palette.primary.main,
    color: '#FFF'
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  logoImg: {
    height: 60,
    width: 60,
  },
  storeName: {
    fontSize: 16,
  },
  logo: {
    width: 180,
    marginTop: 20,
    marginLeft: 20,
  },
  listText: {
    color: theme.palette.secondary.main,
  }
}));

const AdminHeaderDrawer = () => {
  const classes = useStyles();
  let history = useHistory();
  const [drawerShowing, setDrawerShowing] = React.useState(false);

  const toggleDrawer = (value) => {
    setDrawerShowing(value);
  };

  const goPage = (page) => {
    history.push(page);
  };

  const logout = () => {
    localStorage.clear();
    goPage('/');
  }

  const list = () => (
    <div
      className={classes.list}
      role="presentation"
      onClick={() => toggleDrawer(false)}
      onKeyDown={() => toggleDrawer(false)}
    >
      <List>
        <img alt="guestbook.linkpos.com.au" src={Logo} className={classes.logo} />

        <Divider light style={{ marginTop: 20, marginBottom: 20 }} />
        <ListItem button onClick={() => goPage(`/`)} >
          <ListItemIcon><HomeOutlined color="secondary" /></ListItemIcon>
          <ListItemText primary='Home' className={classes.listText} />
        </ListItem>
        <ListItem button onClick={() => goPage(`/admin/qrcode`)} >
          <ListItemIcon><HomeIcon color="secondary" /></ListItemIcon>
          <ListItemText primary='Check-in QR Code' className={classes.listText} />
        </ListItem>
        <ListItem button onClick={() => goPage(`/admin/regisiterrecords`)} >
          <ListItemIcon><ListOutlined color="secondary" /></ListItemIcon>
          <ListItemText primary='Check-in Records' className={classes.listText} />
        </ListItem>
        <ListItem button onClick={() => goPage(`/admin/changePassword`)} >
          <ListItemIcon><LockOutlined color="secondary" /></ListItemIcon>
          <ListItemText primary='Change Password' className={classes.listText} />
        </ListItem>
        <ListItem button onClick={logout} >
          <ListItemIcon><ExitToAppOutlined color="secondary" /></ListItemIcon>
          <ListItemText primary='Logout' className={classes.listText} />
        </ListItem>
      </List>
    </div>
  );

  return (
    <React.Fragment>
      <Drawer open={drawerShowing} onClose={() => toggleDrawer(false)} classes={{ paper: classes.paper }}>
        {list()}
      </Drawer>
      <IconButton onClick={() => toggleDrawer(true)} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
        <MenuIcon color="secondary" />
      </IconButton>
    </React.Fragment>
  );
};

export default AdminHeaderDrawer;